"use client";

import type { FC, Ref } from "react";
import { type ChildrenProp, Flex, Separate, Spacing } from "@huub-web/ui";

import type { AnalysisObservation } from "../../types";
import { AnalysisListItem } from "./components/AnalysisListItem";

export type AnalysisListContentProps = ChildrenProp & {
  observations?: AnalysisObservation[];
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * @deprecated
 */
export const AnalysisListContent: FC<AnalysisListContentProps> = ({
  observations,
  children,
  ref,
  ...props
}) => (
  <Flex ref={ref} {...props} direction="column" gap="m">
    <Spacing />
    <Separate>
      {observations?.map((observation, i) => (
        <AnalysisListItem key={i} observation={observation} />
      ))}
    </Separate>
    {children && (
      <>
        <Spacing />
        {children}
      </>
    )}
  </Flex>
);
